import { BackupStatuses } from 'mbs-ui-shared@models/backupHistory';

export const LastPlanStatusDisplay = {
  [BackupStatuses.None]: 'None',
  [BackupStatuses.Unknown]: 'Unknown',
  [BackupStatuses.Success]: 'Success',
  [BackupStatuses.Interrupted]: 'Interrupted',
  [BackupStatuses.UnexpectedlyClosed]: 'Unexpectedly Closed',
  [BackupStatuses.Running]: 'Running',
  [BackupStatuses.Warning]: 'Warning',
  [BackupStatuses.PlanCreated]: 'Plan Created',
  [BackupStatuses.PlanDeleted]: 'Plan Deleted',
  [BackupStatuses.Scheduled]: 'Scheduled',
  [BackupStatuses.MissingRun]: 'Missed Run'
};
